import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectVipcardRecode(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/mini/vipcardRecode/select`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
// export function deleteUser(data) {
//   return request({
//     url: `/admin/mini/vipcardRecode/delete`,
//     method: "POST",
//     data,
//   });
// }
